var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.4,
    height: 6.58,
    viewBox: "0 0 9.4 6.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.45 -10.621)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.929,22.94H4.47a.47.47,0,0,1,0-.94h8.46a.47.47,0,0,1,0,.94Z",
    transform: "translate(0.45 -8.558)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.47,16.58a.47.47,0,0,1-.332-.8l2.488-2.488L28.138,10.8a.47.47,0,1,1,.665-.665l2.82,2.82a.47.47,0,0,1,0,.665l-2.82,2.82A.469.469,0,0,1,28.47,16.58Z",
    transform: "translate(-17.91 0.621)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGo);
export default __webpack_public_path__ + "static/media/icon_go.09fbcfb41056ecf282152bf33111f5bd.svg";
export { ForwardRef as ReactComponent };